// extracted by mini-css-extract-plugin
module.exports = {"listAction":"List_listAction_2SOtx"};